import apiResource from '@/services/http/api/resource';
import type { Consent, FieldsetField, FieldsetFieldWithDetails, GiftGiverCategory } from '@/types';
import { addDetailsToFieldsetField } from '@/utils/splitConsentLabel';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useConsentStore = defineStore('Consent', () => {
    const consent = ref<Consent>();
    const loader = ref<boolean>(false);
    const giftgiverCategories = ref<GiftGiverCategory[]>();

    const getConsentFields = computed<FieldsetField[]>(() => consent.value?.fieldsets.find(el => el.name === 'consents')?.fields ?? []);

    const getConsentTextFields = computed<FieldsetField[]>(() =>
        getConsentFields.value.filter(field => field.type === 'text')
    );

    const getSplittedLabelConsentFields = computed<FieldsetFieldWithDetails[]>(() =>
        addDetailsToFieldsetField(getConsentFields.value)
    );

    const getSplittedLabelTextFields = computed<FieldsetFieldWithDetails[]>(() =>
        addDetailsToFieldsetField(getConsentTextFields.value)
    );

    // @TODO: add correct types after types from http api are added
    const fetchConsent = async () => {
        const { data } = await apiResource.getConsent();
        consent.value = data;
        return data;
    };

    const fetchGiftgiverCategories = async () => {
        const { data } = await apiResource.getGiftgiverCategories();
        giftgiverCategories.value = data?.data ?? [];
        return data?.data ?? [];
    };

    const init = async () => {
        loader.value = true;
        await Promise.all([fetchConsent(), fetchGiftgiverCategories()]);
        loader.value = false;
    };

    return {
        consent,
        loader,
        giftgiverCategories,
        getConsentFields,
        getConsentTextFields,
        getSplittedLabelConsentFields,
        getSplittedLabelTextFields,
        fetchConsent,
        fetchGiftgiverCategories,
        init
    };
});
